
import React, { useState, useEffect } from "react";
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Form,
  Row,
  Col,
  Label,
  Button,
  Input,
} from "reactstrap";
import { geocodeByPlaceId } from "react-google-places-autocomplete";
import { geocodeByAddress, getLatLng } from "react-google-places-autocomplete";
import { AddressModel } from "models/City";
import CustomGooglePlacesAutocompleteOrders from "components/Common/auto-complete-order";
import { AddressType } from "enum/AddressType";
import moment from "moment-timezone";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { environment } from "environment/environment";
import { startOfDay } from "date-fns";
import { VehicleType } from "enum/VehicleType";
import { DeliverOption } from "enum/DeliveryOption";
import { InputValueType } from "components/Common/auto-complete/google-places-autocomplete";
import { Radio, RadioChangeEvent, Select } from "antd";
import { OrderResponse } from "models/orderResponse";
import { AuthData, useAuth } from "context/AuthProvider";
import { OrderService } from "services/OrderService";
import { toast } from "react-toastify";
import * as XLSX from 'xlsx';
import Papa from 'papaparse';
import { Puff } from "react-loader-spinner";
import { getMinimumDeliveryDateTime, getSerivceSettingsType, normalizeMomentToMinute } from "helpers/formHelpers";

interface Props {
  isOpen: boolean;
  toggle: () => void;
  onSuccess?: () => void;
  setIsModified: (value: boolean) => void;
  isModified: boolean;
}

interface DeliveryEntry {
  id: string;
  deliverUnit: string;
  deliverContactName: string;
  deliverContactPhone: string;
  deliverCompany: string;
  vehicleType: string;
  totalWeight: string;
  totalItems: string;
  description: string;
  deliveryOption?: DeliverOption;
  sentBy: string;
  sizeDescription: string;
  orderId: string;
  deliveryAddress?: AddressModel;
  bulkRequestId: string;
  price?: number;
  totalDistance?: number;
}

const AddDeliveryEntryModal: React.FC<{
  isOpen: boolean;
  toggle: () => void;
  onSave: (entry: DeliveryEntry) => void;
  pickupAddress: AddressModel | undefined;
  pickupDateTime: moment.Moment;
  deliveryDateTime: moment.Moment;
  userId?: string;
  bulkRequestId?: string;
  defaultVehicleType?: string;
  defaultDeliveryOption?: DeliverOption;
}> = ({ isOpen, toggle, onSave, pickupAddress, pickupDateTime, deliveryDateTime, userId, bulkRequestId, defaultVehicleType,
  defaultDeliveryOption }) => {
    const [values, setValues] = useState<Omit<DeliveryEntry, 'id'>>({
      deliverUnit: "",
      deliverContactName: "",
      deliverContactPhone: "",
      deliverCompany: "",
      vehicleType: defaultVehicleType || VehicleType.CAR,
      totalWeight: "",
      totalItems: "",
      description: "",
      deliveryOption: defaultDeliveryOption || DeliverOption.DROP_AT_DOOR,
      // deliveryOption: defaultDeliveryOption ?? ("" as any),
      sentBy: "",
      sizeDescription: "",
      orderId: "",
      bulkRequestId: ""
    });

    const [deliveryAddress, setDeliveryAddress] = useState<AddressModel>();
    const [delvalue, setdelValue] = useState<InputValueType>({ label: "", placeId: "" });
    const [isDeliverClicked, setIsDeliverClicked] = useState<boolean>(false);
    const [isLoading, setIsLoading] = useState(false);
    const [touched, setTouched] = useState<Record<string, boolean>>({
      deliverContactName: false,
      deliverContactPhone: false,
      totalWeight: false,
      totalItems: false,
      deliveryOption: false
    });
    const [errors, setErrors] = useState<Record<string, string>>({
      deliverContactName: '',
      deliverContactPhone: '',
      totalWeight: '',
      totalItems: '',
      deliveryOption: ''
    });
    const validateField = (name: string, value: string) => {
      let error = '';

      switch (name) {
        case 'deliverContactName':
          if (!value.trim()) error = 'Contact Name is required';
          break;
        // case 'deliverContactPhone':
        //   if (!value.trim()) {
        //     error = 'Contact Phone is required';
        //   } else if (!/^(?:(?:\+1|1-)?(?:\(\d{3}\)|\d{3})[-.]?\d{3}[-.]?\d{4}|(?:\+1|1-)?\d{10})$/.test(value)) {
        //     error = 'Please enter a valid phone number';
        //   }
        //   break;
        case 'deliverContactPhone':
          if (!/^(?:(?:\+1|1-)?(?:\(\d{3}\)|\d{3})[-.]?\d{3}[-.]?\d{4}|(?:\+1|1-)?\d{10})$/.test(value)) {
            error = 'Please enter a valid phone number';
          }
          break;
        case 'totalWeight':
          if (!value || isNaN(Number(value))) {
            error = 'Weight is required';
          } else if (Number(value) <= 0) {
            error = 'Weight must be greater than 0';
          }

          break;
        case 'totalItems':
          if (!value || isNaN(Number(value))) {
            error = 'Number of items is required';
          } else if (Number(value) <= 0) {
            error = 'Number of items must be greater than 0';
          }
          break;
        case 'deliveryOption':
          if (!value) error = 'Delivery Method is required';
          break;
      }

      return error;
    };
    const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
      const { name, value } = e.target;
      setValues(prev => ({
        ...prev,
        [name]: value
      }));

      if (touched[name]) {
        const error = validateField(name, value);
        setErrors(prev => ({ ...prev, [name]: error }));
      }
    };

    const handleBlur = (e: React.FocusEvent<HTMLInputElement>) => {
      const { name } = e.target;
      setTouched(prev => ({ ...prev, [name]: true }));

      // Validate the field
      const error = validateField(name, values[name as keyof typeof values] as string);
      setErrors(prev => ({ ...prev, [name]: error }));
    };

    const mapprops: any = {
      componentRestrictions: { country: "ca" },
      locationRestriction: {
        north: 56.85,
        south: 41.6,
        east: -74.0,
        west: -95.15,
      },
    };

    const handleAddress = async (label: string, place_id: string, type: string) => {
      if (place_id !== "") {
        const address = label;
        await geocodeByPlaceId(place_id)
          .then(([place]: google.maps.GeocoderResult[]) => {
            const { long_name: postalCode = "" } =
              place.address_components.find(c => c.types.includes("postal_code")) || {};
            const latLng = {
              lat: place.geometry.location.lat(),
              lng: place.geometry.location.lng(),
            };
            if (type === AddressType.delivery) {
              setDeliveryAddress({ city: address, lat: latLng.lat, lng: latLng.lng, postalCode });
            }
          })
          .catch(err => {
            console.log(err);
          });
      }
    };

    const validateForm = () => {
      const newErrors = {
        deliverContactName: validateField('deliverContactName', values.deliverContactName),
        deliverContactPhone: validateField('deliverContactPhone', values.deliverContactPhone),
        totalWeight: validateField('totalWeight', values.totalWeight),
        totalItems: validateField('totalItems', values.totalItems),
        deliveryOption: validateField('deliveryOption', values.deliveryOption ?? "")
      };

      setErrors(newErrors);
      setTouched({
        deliverContactName: true,
        deliverContactPhone: true,
        totalWeight: true,
        totalItems: true,
        deliveryOption: true
      });

      return !Object.values(newErrors).some(error => error);
    };

    const handleSave = async () => {
      if (!deliveryAddress) {
        toast.error("Please select a delivery address", {
          position: toast.POSITION.BOTTOM_RIGHT,
          className: "foo-bar",
        });
        return;
      }

      if (!pickupAddress) {
        toast.error("Pickup address is required", {
          position: toast.POSITION.BOTTOM_RIGHT,
          className: "foo-bar",
        });
        return;
      }
      if (!validateForm()) {
        return;
      }

      setIsLoading(true);

      try {
        const pickupData = {
          lat: pickupAddress.lat,
          lng: pickupAddress.lng,
          city: pickupAddress.city,
          postalCode: pickupAddress.postalCode,
          unit: "",
          street: "",
          companyName: "",
          contactName: "",
          contactPhone: "",
        };
        const deliveryData = {
          lat: deliveryAddress.lat,
          lng: deliveryAddress.lng,
          city: deliveryAddress.city,
          postalCode: deliveryAddress.postalCode,
          unit: values.deliverUnit,
          street: "",
          companyName: values.deliverCompany,
          contactName: values.deliverContactName,
          contactPhone: values.deliverContactPhone,
          vehicleType: defaultVehicleType,
          weight: values.totalWeight,
          quantity: values.totalItems,
          deliveryOption: defaultDeliveryOption,
          notes: values.description,
        };

        const response = await OrderService.createBulkOrder(
          pickupData,
          deliveryData,
          pickupDateTime.toISOString(),
          deliveryDateTime.toISOString(),
          getSerivceSettingsType(pickupDateTime, deliveryDateTime),
          userId,
          bulkRequestId
        );

        if (response.success) {
          const entry: DeliveryEntry = {
            ...values,
            id: Date.now().toString(),
            deliveryAddress,
            bulkRequestId: (response as any).bulkRequestId,
            price: (response as any).price,
            totalDistance: (response as any).totalDistance,
            orderId: (response as any).orderId

          };

          toast.success("Delivery entry added successfully", {
            position: toast.POSITION.BOTTOM_RIGHT,
            className: "foo-bar",
          });
          onSave(entry);

          // Reset form
          setValues({
            deliverUnit: "",
            deliverContactName: "",
            deliverContactPhone: "",
            deliverCompany: "",
            vehicleType: VehicleType.CAR,
            totalWeight: "",
            totalItems: "",
            description: "",
            deliveryOption: DeliverOption.DROP_AT_DOOR,
            sentBy: "",
            sizeDescription: "",
            orderId: "",
            bulkRequestId: ""
          });
          setdelValue({ label: "", placeId: "" });
          setDeliveryAddress(undefined);
          setErrors({
            deliverContactName: '',
            deliverContactPhone: '',
            totalWeight: '',
            totalItems: '',
            deliveryOption: ''
          });
          setTouched({
            deliverContactName: false,
            deliverContactPhone: false,
            totalWeight: false,
            totalItems: false,
            deliveryOption: false
          });
          toggle();
        } else {
          toast.error(response.message || "Failed to submit bulk order", {
            position: toast.POSITION.BOTTOM_RIGHT,
            className: "foo-bar",
          });
        }
      } catch (error) {
        console.error("Error adding delivery entry:", error);
        toast.error("Failed to add delivery entry", {
          position: toast.POSITION.BOTTOM_RIGHT,
          className: "foo-bar",
        });
      } finally {
        setIsLoading(false);
      }
    };
    const handleDeliverModal = () => {
      setIsDeliverClicked(!isDeliverClicked);
    };

    return (
      <Modal isOpen={isOpen} toggle={toggle} centered size="xl">
        <ModalHeader toggle={toggle}>Add Another Delivery </ModalHeader>
        <ModalBody>
          <div className="px-5 py-2">
            <Form>
              <Row>
                <Col lg="6" md="12">
                  <div className="form-group">
                    <div className="d-flex flex-wrap align-items-center">
                      <Label className="place-order-title">
                        Delivery Address<Label className="title-star">*</Label>
                      </Label>
                      <div className="label-wrap" onClick={handleDeliverModal}>
                        <span className="custom-label">{"Use Address Book"}</span>
                      </div>
                    </div>
                  </div>
                  <div>
                    <CustomGooglePlacesAutocompleteOrders
                      apiKey={environment.google_maps_key}
                      autocompletionRequest={mapprops}
                      addressType={AddressType.delivery}
                      value={delvalue}
                      setValue={setdelValue}
                      selectProps={{
                        name: "address",
                      }}
                      handleAddress={handleAddress}
                    />
                  </div>
                </Col>
                <Col lg="6">
                  <div className="mb-3 form-group">
                    <Label className="place-order-title">Contact Name</Label>
                    <Input
                      value={values.deliverContactName}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      name="deliverContactName"
                      type="text"
                      className={
                        errors.deliverContactName && touched.deliverContactName
                          ? "input-error form-control"
                          : "form-control"
                      }
                    />
                    {errors.deliverContactName && touched.deliverContactName && (
                      <p className="error place-order-title">{errors.deliverContactName}</p>
                    )}
                  </div>
                </Col>
              </Row>

              <Row>
                <Col lg="6">
                  <div className="mb-3 form-group">
                    <Label className="place-order-title">Contact Phone</Label>
                    <Input
                      value={values.deliverContactPhone}
                      onChange={handleChange}
                      name="deliverContactPhone"
                      type="text"
                      className="form-control"
                    />
                    {errors.deliverContactPhone && touched.deliverContactPhone && (
                      <p className="error place-order-title">{errors.deliverContactPhone}</p>
                    )}
                  </div>
                </Col>
                <Col lg="6">
                  <div className="mb-3 form-group">
                    <Label className="place-order-title">Company Name</Label>
                    <Input
                      value={values.deliverCompany}
                      onChange={handleChange}
                      name="deliverCompany"
                      type="text"
                      className="form-control"
                    />
                  </div>
                </Col>
              </Row>

              <Row>

                <Col lg="6">
                  <div className="mb-3 form-group">
                    <Label className="place-order-title">Total Weight (lbs)</Label>
                    <Input
                      value={values.totalWeight}
                      onChange={handleChange}
                      name="totalWeight"
                      type="number"
                      min="1"
                      className="form-control"
                    />
                    {errors.totalWeight && touched.totalWeight && (
                      <p className="error place-order-title">{errors.totalWeight}</p>
                    )}
                  </div>
                </Col>

                <Col lg="6">
                  <div className="mb-3 form-group">
                    <Label className="place-order-title">Total Number of Items</Label>
                    <Input
                      value={values.totalItems}
                      onChange={handleChange}
                      name="totalItems"
                      type="number"
                      min="1"
                      className="form-control"
                    />
                    {errors.totalItems && touched.totalItems && (
                      <p className="error place-order-title">{errors.totalItems}</p>
                    )}
                  </div>
                </Col>
              </Row>

              <Row>
                <Col lg="6">
                  <div className="mb-3 form-group">
                    <Label className="place-order-title">Notes</Label>
                    <Input
                      value={values.description}
                      onChange={handleChange}
                      name="description"
                      type="text"
                      className="form-control"
                    />
                  </div>
                </Col>
                {/* <Col lg="6">
                <div className="mb-3 form-group">
                  <Label className="place-order-title">Sent By</Label>
                  <Input
                    value={values.sentBy}
                    onChange={handleChange}
                    name="sentBy"
                    type="text"
                    className="form-control"
                  />
                </div>
              </Col> */}
              </Row>

              {/* <Row>
              <Col lg="6">
                <div className="mb-3 form-group">
                  <Label className="place-order-title">Item Description/Size (optional)</Label>
                  <Input
                    value={values.sizeDescription}
                    onChange={handleChange}
                    name="sizeDescription"
                    type="text"
                    className="form-control"
                  />
                </div>
              </Col>
              <Col lg="6">
                <div className="mb-3 form-group">
                  <Label className="place-order-title">Unit Number</Label>
                  <Input
                    value={values.deliverUnit}
                    onChange={handleChange}
                    name="deliverUnit"
                    type="text"
                    className="form-control unit-number py-2"
                  />
                </div>
              </Col>
            </Row> */}
            </Form>
          </div>
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" size="sm" onClick={toggle}>
            Cancel
          </Button>
          <Button color="primary" size="sm" onClick={handleSave}>
            Add
          </Button>
        </ModalFooter>
      </Modal>
    );
  };

function roundUpToNext15Min(momentDate: any) {
  const remainder = 15 - (momentDate.minute() % 15);
  if (remainder !== 15) {
    return momentDate.add(remainder, 'minutes').startOf('minute');
  }
  return momentDate.startOf('minute');
};

const changeTimezone = (date: Date, ianatz: string): Date => {
  const invdate = new Date(
    date.toLocaleString("en-US", {
      timeZone: ianatz,
    })
  );
  const diff = date.getTime() - invdate.getTime();
  return new Date(date.getTime() - diff);
};

const validateAndCorrectTime = (date: Date): Date => {
  const pickupDateTimeObj = normalizeMomentToMinute(moment(date));
  const currentTime = normalizeMomentToMinute(moment().tz("America/Toronto"));

  const minTime = moment(pickupDateTimeObj).set({ hour: 9, minute: 0, second: 0, millisecond: 0 });
  let maxTime = moment(pickupDateTimeObj).set({ hour: 21, minute: 0, second: 0, millisecond: 0 });

  if (pickupDateTimeObj.isSame(currentTime, "day")) {
    if (pickupDateTimeObj.isBefore(currentTime)) {
      const rounded = moment(currentTime).add(15 - (currentTime.minute() % 15), 'minutes').startOf('minute');
      return rounded.toDate();
    } else if (pickupDateTimeObj.isBefore(minTime)) {
      return currentTime.toDate();
    } else if (pickupDateTimeObj.isAfter(maxTime)) {
      return maxTime.toDate();
    }
  } else {
    if (pickupDateTimeObj.isBefore(minTime)) return minTime.toDate();
    if (pickupDateTimeObj.isAfter(maxTime)) return maxTime.toDate();
  }

  return pickupDateTimeObj.toDate();
};

const CreateBulk: React.FC<Props> = ({ isOpen, toggle, isModified, setIsModified }) => {

  const [pickupAddress, setPickupAddress] = useState<AddressModel>();
  const [pickupDateTime, setPickupDateTime] = useState<moment.Moment>(normalizeMomentToMinute(moment.tz("America/Toronto")));
  const [deliveryDateTime, setDeliveryDateTime] = useState<moment.Moment>(normalizeMomentToMinute(moment.tz("America/Toronto").add(5, "hours")));
  const [pickupValue, setPickupValue] = useState<InputValueType>({ label: "", placeId: "" });
  const [currentDateTime] = useState(moment.tz("America/Toronto"));
  const [mindate, setMindate] = useState(moment.tz("America/Toronto"));
  const [showAddModal, setShowAddModal] = useState(false);
  const [deliveryEntries, setDeliveryEntries] = useState<DeliveryEntry[]>([]);
  const [fieldsLocked, setFieldsLocked] = useState(false);
  const [bulkRequestId, setBulkRequestId] = useState<string | null>(null);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [selectedOrders, setSelectedOrders] = useState<string[]>([]);
  const [showAllEntries, setShowAllEntries] = useState(false);
  const [pickupVehicleType, setPickupVehicleType] = useState<string>(VehicleType.CAR);
  const [uploadErrors, setUploadErrors] = useState<string[]>([]);
  const fileInputRef = React.useRef<HTMLInputElement | null>(null);
  const [uploadedFileName, setUploadedFileName] = useState<string | null>(null);
  const [uploadSuccess, setUploadSuccess] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [totalPrice, setTotalPrice] = useState<number>(0);

  // const [pickupDeliveryOption, setPickupDeliveryOption] = useState<DeliverOption>(DeliverOption.DROP_AT_DOOR);
  const [pickupDeliveryOption, setPickupDeliveryOption] = useState<DeliverOption | undefined>(undefined);
  const [user] = useAuth() as AuthData;
  const userId = user?._id;

  useEffect(() => {
    const toronto = changeTimezone(new Date(), "America/Toronto");

    if (toronto.getHours() >= 9 && toronto.getHours() < 21) {
      const pickup = moment(toronto);
      const pickupHour = pickup.hour();

      const roundedTime = roundUpToNext15Min(moment.tz("America/Toronto"));
      setPickupDateTime(moment(roundedTime));
      setMindate(pickup);

      let maxHour = 17; // default 5 PM
      if (pickupHour >= 15) maxHour = 18; // ≥ 3 PM → 6 PM
      if (pickupHour >= 16) maxHour = 19; // ≥ 4 PM → 7 PM
      if (pickupHour >= 17) maxHour = 20; // ≥ 5 PM → 8 PM
      if (pickupHour >= 18) maxHour = 21; // ≥ 6 PM → 9 PM
      if (pickupHour >= 19) maxHour = 22; // ≥ 7 PM → 10 PM
      if (pickupHour >= 20) maxHour = 23; // ≥ 8 PM → 11 PM

      setDeliveryDateTime(pickup.hour(maxHour).minute(0).second(0).millisecond(0));
    } else if (toronto.getHours() >= 21) {
      setMindate(moment(toronto).add(1, "days"));
      setPickupDateTime(moment(toronto).hour(9).minute(0).second(0).millisecond(0).add(1, "days"));
      setDeliveryDateTime(moment(toronto).hour(17).minute(0).second(0).millisecond(0).add(1, "days"));
    } else {
      setPickupDateTime(moment(toronto).hour(9).minute(0).second(0).millisecond(0));
      setDeliveryDateTime(moment(toronto).hour(17).minute(0).second(0).millisecond(0));
    }
  }, []);

  useEffect(() => {
    if (deliveryEntries.length > 0) {
      const total = deliveryEntries.reduce(
        (sum, entry) => sum + (Number(entry.price) || 0),
        0
      );
      setTotalPrice(total);
    } else {
      setTotalPrice(0);
    }
  }, [deliveryEntries]);

  const handleVehicleTypeChange = (e: RadioChangeEvent) => {
    setPickupVehicleType(e.target.value);
  };

  const handleDeliveryOptionChange = (value: DeliverOption) => {
    setPickupDeliveryOption(value);
  };

  const handlePickupDateChange = (date: Date) => {
    if (fieldsLocked) return;
    const corrected = validateAndCorrectTime(date);
    setPickupDateTime(normalizeMomentToMinute(moment(corrected)));
    handleDeliverDatefromPickupChange(corrected);
  };

  const handleDeliverDatefromPickupChange = (date: Date | null) => {
    if (fieldsLocked || !date) return;
    const pickup = normalizeMomentToMinute(moment(date));
    const pickupHour = pickup.hour();

    let maxHour = 17; // default 5 PM
    if (pickupHour >= 15) maxHour = 18; // ≥ 3 PM → 6 PM
    if (pickupHour >= 16) maxHour = 19; // ≥ 4 PM → 7 PM
    if (pickupHour >= 17) maxHour = 20; // ≥ 5 PM → 8 PM
    if (pickupHour >= 18) maxHour = 21; // ≥ 6 PM → 9 PM
    if (pickupHour >= 19) maxHour = 22; // ≥ 7 PM → 10 PM
    if (pickupHour >= 20) maxHour = 23; // ≥ 8 PM → 11 PM
    setDeliveryDateTime(pickup.clone().set({ hour: maxHour, minute: 0, second: 0, millisecond: 0 }));
  };

  const getDeliveryMinTime = () => {
    const now = normalizeMomentToMinute(moment().tz("America/Toronto"));
    const pickupPlus2Hours = getMinimumDeliveryDateTime(pickupDateTime);

    if (pickupDateTime.isSame(now, "day")) {
      const roundedNow = now.clone().add(15 - (now.minute() % 15), "minutes").startOf("minute");
      return moment.max(pickupPlus2Hours, roundedNow).toDate();
    }
    return pickupPlus2Hours.toDate();
  };

  const getDeliveryMaxTime = () => {
    const pickupMoment = moment(pickupDateTime);
    const pickupHour = pickupDateTime.hour();
    const two45PM = pickupMoment.clone().set({ hour: 14, minute: 45, second: 0, millisecond: 0 });

    let maxHour = 17;
    if (pickupMoment.isAfter(two45PM)) {
      maxHour = 21;
    }
    if (pickupHour > 18) {
      maxHour = 23;
    }
    return moment(pickupDateTime)
      .set({ hour: maxHour, minute: 0, second: 0, millisecond: 0 })
      .toDate();
  };

  const handleDeliveryDateChange = (date: Date | null) => {
    if (fieldsLocked || !date) return;
    const pickPlus2 = getMinimumDeliveryDateTime(pickupDateTime);
    const selected = normalizeMomentToMinute(moment(date));

    let maxAllowed = moment(date).set({ hour: 17, minute: 0, second: 0, millisecond: 0 }); // default 5 PM

    if (pickupDateTime.hour() >= 17) {
      maxAllowed = moment(date).set({ hour: 23, minute: 0, second: 0, millisecond: 0 });
    } else if (pickupDateTime.hour() >= 15) {
      maxAllowed = moment(date).set({ hour: 21, minute: 0, second: 0, millisecond: 0 });
    }

    if (selected.isAfter(maxAllowed)) {
      setDeliveryDateTime(maxAllowed);
    } else if (selected.isBefore(pickPlus2)) {
      setDeliveryDateTime(pickPlus2);
    } else {
      setDeliveryDateTime(selected);
    }
  };

  const mapprops = {
    componentRestrictions: { country: "ca" },
    locationRestriction: {
      north: 56.85,
      south: 41.6,
      east: -74.0,
      west: -95.15,
    },
  };

  const handleAddress = async (label: string, place_id: string, type: string) => {
    if (fieldsLocked) return;
    if (place_id !== "") {
      const address = label;
      await geocodeByPlaceId(place_id)
        .then(([place]: google.maps.GeocoderResult[]) => {
          const { long_name: postalCode = "" } =
            place.address_components.find((c) => c.types.includes("postal_code")) || {};
          const latLng = {
            lat: place.geometry.location.lat(),
            lng: place.geometry.location.lng(),
          };
          if (type === AddressType.pickup) {
            setPickupAddress({ city: address, lat: latLng.lat, lng: latLng.lng, postalCode });
          }
        })
        .catch((err) => {
          console.log(err);
        });
    }
  };

  const isPickupDetailsComplete = (): boolean => {
    return !!pickupAddress && !!pickupDateTime && !!deliveryDateTime && !!pickupDeliveryOption;
  };

  const handleAddDeliveryEntry = (entry: DeliveryEntry) => {
    setDeliveryEntries([...deliveryEntries, entry]);
    setBulkRequestId(entry.bulkRequestId);
    setFieldsLocked(true);
  };

  const handleSubmit = async () => {
    if (!pickupAddress) {
      toast.error("Please select a pickup address", {
        position: toast.POSITION.BOTTOM_RIGHT,
        className: "foo-bar",
      });
      return;
    }
    if (deliveryEntries.length === 0) {
      toast.error("Please add at least one delivery entry", {
        position: toast.POSITION.BOTTOM_RIGHT,
        className: "foo-bar",
      });
      return;
    }
    if (!bulkRequestId) {
      toast.error("Bulk request ID is missing", {
        position: toast.POSITION.BOTTOM_RIGHT,
        className: "foo-bar",
      });
      return;
    }

    setIsSubmitting(true);

    try {
      if (!userId) {
        toast.error("User not authenticated", {
          position: toast.POSITION.BOTTOM_RIGHT,
          className: "foo-bar",
        });
        return;
      }

      const response = await OrderService.submitBulkRequest(
        bulkRequestId,
        userId
      );

      if (response.success) {
        toast.success("Bulk order submitted successfully!", {
          position: toast.POSITION.BOTTOM_RIGHT,
          className: "foo-bar",
        });
        toggle();
        setIsModified(!isModified);
        // Reset state
        setPickupAddress(undefined);
        setPickupValue({ label: "", placeId: "" });
        setDeliveryEntries([]);
        setBulkRequestId(null);
        setFieldsLocked(false);
        setUploadErrors([]);
        toggle();
      } else {
        toast.error(response.message || "Failed to submit bulk order", {
          position: toast.POSITION.BOTTOM_RIGHT,
          className: "foo-bar",
        });
      }
    } catch (error) {
      setIsSubmitting(false);
      console.error("Error submitting bulk order:", error);
      toast.error("Failed to submit bulk order", {
        position: toast.POSITION.BOTTOM_RIGHT,
        className: "foo-bar",
      });
    } finally {
      setIsSubmitting(false);
    }
  };

  const geocodeRawAddress = async (fullAddress: string): Promise<AddressModel> => {
    try {
      const [place] = await geocodeByAddress(fullAddress);

      const postalCode =
        place.address_components.find((c) => c.types.includes("postal_code"))
          ?.long_name || "";

      const { lat, lng } = await getLatLng(place);

      const city =
        place.address_components.find((c) =>
          c.types.includes("locality") || c.types.includes("administrative_area_level_2")
        )?.long_name || "Unknown";

      return {
        city,
        lat,
        lng,
        postalCode,
      };
    } catch (error) {
      console.error("Geocoding failed for:", fullAddress, error);
      throw new Error(`Failed to geocode address: ${fullAddress}`);
    }
  };

  const handleDeliveryEntryAdd = () => {
    const currentTime = moment()
      .tz('America/Toronto')
      .second(0)
      .millisecond(0);

    const selectedPickupTime = moment.tz(
      {
        year: pickupDateTime.year(),
        month: pickupDateTime.month(),
        date: pickupDateTime.date(),
        hour: pickupDateTime.hour(),
        minute: pickupDateTime.minute(),
        second: 0
      },
      'America/Toronto'
    );
    if (selectedPickupTime.isBefore(currentTime)) {
      toast.error("Pickup time cannot be in the past.", {
        position: toast.POSITION.BOTTOM_RIGHT,
        className: "foo-bar",
        style: { marginBottom: "4rem" },
      });
      const correctedPickupTime = roundUpToNext15Min(moment.tz("America/Toronto"));
      setPickupDateTime(moment(correctedPickupTime));

    }
    setShowAddModal(true)
    return; // Stop the form submission if the check fails
  }


  const stopLoading = () => setIsLoading(false);

  const handleFileUpload = async (e: React.ChangeEvent<HTMLInputElement>) => {
    setUploadErrors([]);
    setIsLoading(true);

    // ✅ CASE 1: User clicked “Cancel” — no file chosen
    if (!e.target.files || e.target.files.length === 0) {
      console.warn("[DEBUG] No file selected or upload canceled.");
      if (fileInputRef.current) {
        fileInputRef.current.value = "";
      }
      stopLoading();
      return;
    }

    const currentTime = moment()
      .tz('America/Toronto')
      .second(0)
      .millisecond(0);

    const selectedPickupTime = moment.tz(
      {
        year: pickupDateTime.year(),
        month: pickupDateTime.month(),
        date: pickupDateTime.date(),
        hour: pickupDateTime.hour(),
        minute: pickupDateTime.minute(),
        second: 0
      },
      'America/Toronto'
    );
    if (selectedPickupTime.isBefore(currentTime)) {

      toast.error("Pickup time cannot be in the past.", {
        position: toast.POSITION.BOTTOM_RIGHT,
        className: "foo-bar",
        style: { marginBottom: "4rem" },
      });
      const correctedPickupTime = roundUpToNext15Min(moment.tz("America/Toronto"));
      setPickupDateTime(moment(correctedPickupTime));
      stopLoading();
      return;
    }

    const file = e.target.files?.[0];
    if (!file) {
      if (fileInputRef.current) {
        fileInputRef.current.value = ""; // clear input so user can click again
      }
      console.warn("[DEBUG] No file selected.");
      return;
    }

    if (!pickupAddress) {
      toast.error("Please select a pickup address first", {
        position: toast.POSITION.BOTTOM_RIGHT,
        className: "foo-bar",
      });
      stopLoading(); // ✅ add this
      return;
    }

    const fileName = file.name.toLowerCase();
    const reader = new FileReader();
    reader.onload = async (event) => {

      const data = event.target?.result;
      if (!data) {
        console.error("[DEBUG] No data read from file.");
        return;
      }

      let rows: any[] = [];

      try {
        if (fileName.endsWith(".csv")) {

          Papa.parse(data as string, {
            header: true,
            skipEmptyLines: true,
            complete: (r: { data: any[] }) => {
              rows = r.data as any[];
              console.log("[DEBUG] Parsed CSV rows count:", rows.length);
            },
            error: (err: any) => {
              console.error("[DEBUG] PapaParse error:", err);
            },
          });
        } else if (fileName.endsWith(".xlsx") || fileName.endsWith(".xls")) {

          try {
            const workbook = XLSX.read(data, { type: "binary" });

            if (workbook.SheetNames.length === 0) {
              toast.error("No sheets found in the Excel file.", {
                position: toast.POSITION.BOTTOM_RIGHT,
                className: "foo-bar",
              });
              return;
            }

            const firstSheetName = workbook.SheetNames[0];
            const firstSheet = workbook.Sheets[firstSheetName];
            rows = XLSX.utils.sheet_to_json(firstSheet);

          } catch (ex) {

            toast.error("Failed to parse Excel file", {
              position: toast.POSITION.BOTTOM_RIGHT,
              className: "foo-bar",
            });
            return;
          }
        } else {

          toast.error("Unsupported file format", {
            position: toast.POSITION.BOTTOM_RIGHT,
            className: "foo-bar",
          });
          stopLoading();
          return;
        }

        const normalize = (obj: any) =>
          Object.fromEntries(Object.entries(obj).map(([k, v]) => [k.trim().toLowerCase(), v]));
        rows = rows.map(normalize);

        // ✅ Basic validation
        if (!rows.length || !rows[0]) {
          toast.error("The uploaded file is empty or invalid", {
            position: toast.POSITION.BOTTOM_RIGHT,
            className: "foo-bar",
          });
          stopLoading();
          return;
        }

        const required = ["address", "contact name", "contact phone", "total weight (lbs)", "total items"];
        const missing = required.filter((h) => !(h in rows[0]));
        if (missing.length) {
          toast.error(`Missing columns: ${missing.join(", ")}`, {
            position: toast.POSITION.BOTTOM_RIGHT,
            className: "foo-bar",
          });
          stopLoading();
          return;
        }

        // ✅ Geocode and prepare
        const rowErrors: string[] = [];

        const payloadDeliveries = await Promise.all(
          rows.map(async (row, idx) => {
            try {
              const fullAddress = `${row["address"]}, ${row["city"] || ""}, ${row["postal code"] || ""}`;
              const geo = await geocodeRawAddress(fullAddress);

              return {
                lat: geo.lat,
                lng: geo.lng,
                city: fullAddress,
                postalCode: row["postal code"],
                unit: row["unit"] || "",
                street: row["street"] || "",
                companyName: row["company name"] || "",
                contactName: row["contact name"],
                contactPhone: row["contact phone"],
                vehicleType: pickupVehicleType,
                weight: String(row["total weight (lbs)"]),
                quantity: String(row["total items"]),
                notes: row["notes"] || "",
                deliveryOption: pickupDeliveryOption,
                price: 0, // ✅ prevent backend TypeError
              };
            } catch (err) {
              rowErrors.push(`Row ${idx + 2}: Failed to geocode "${row["address"]}"`);
              console.error(`Row ${idx + 2} geocode failed:`, row, err);
              return null;
            }
          })
        );

        const sortedRowErrors = rowErrors.sort((a, b) => {
          const rowA = parseInt(a.match(/Row\s+(\d+)/)?.[1] || "0", 10);
          const rowB = parseInt(b.match(/Row\s+(\d+)/)?.[1] || "0", 10);
          return rowA - rowB;
        });

        const validDeliveries = payloadDeliveries.filter(
          (d): d is NonNullable<typeof d> => d !== null
        );

        setUploadErrors(sortedRowErrors);

        if (validDeliveries.length === 0) {
          toast.error("All uploaded rows had invalid addresses. Nothing to upload.", {
            position: toast.POSITION.BOTTOM_RIGHT,
            className: "foo-bar",
          });
          stopLoading();
          return;
        }

        // ✅ Upload valid deliveries
        const { bulkRequestId, orderIds, total, prices, totalDistance } =
          await OrderService.uploadBulkFile(
            {
              lat: pickupAddress.lat,
              lng: pickupAddress.lng,
              city: pickupAddress.city,
              postalCode: pickupAddress.postalCode || "",
            },
            validDeliveries,
            pickupDateTime.toISOString(),
            deliveryDateTime.toISOString(),
            getSerivceSettingsType(pickupDateTime, deliveryDateTime),
          );
        setTotalPrice(total || 0);

        // ✅ Map results to DeliveryEntry
        const createdEntries: DeliveryEntry[] = orderIds.map((id: string, idx: number) => ({
          id: Date.now().toString() + idx,
          deliverUnit: validDeliveries[idx].unit || "",
          deliverContactName: validDeliveries[idx].contactName,
          deliverContactPhone: validDeliveries[idx].contactPhone,
          deliverCompany: validDeliveries[idx].companyName || "",
          vehicleType: pickupVehicleType,
          totalWeight: String(validDeliveries[idx].weight),
          totalItems: String(validDeliveries[idx].quantity),
          description: validDeliveries[idx].notes || "",
          deliveryOption: pickupDeliveryOption,
          sentBy: "",
          sizeDescription: "",
          orderId: id,
          bulkRequestId,
          price: prices?.[idx] ?? 0,
          totalDistance: totalDistance?.[idx] ?? 0,
          deliveryAddress: validDeliveries[idx] as AddressModel,
        }));

        setDeliveryEntries((prev) => [...prev, ...createdEntries]);
        setBulkRequestId(bulkRequestId);
        setFieldsLocked(true);
        setUploadSuccess(true);
        setUploadedFileName(file.name);

        toast.success(`${total} entries added from file`, {
          position: toast.POSITION.BOTTOM_RIGHT,
          className: "foo-bar",
        });
        stopLoading();

      } catch (err) {
        console.error("[DEBUG] Unexpected error in reader.onload:", err);
      } finally {
        setIsLoading(false);
        stopLoading();
      }
    };

    if (fileName.endsWith(".csv")) reader.readAsText(file);
    else reader.readAsBinaryString(file);
  };

  const handleDownloadPdf = (bulkRequestId: string) => {
    if (!bulkRequestId) {
      toast.error("Invalid request ID.", {
        position: toast.POSITION.BOTTOM_RIGHT,
        className: "foo-bar",
      });
      return;
    }
    OrderService.generateBulkOrderPdf(bulkRequestId).then(res => {
      if (res) {
        try {
          const pdfBlob = new Blob([res as unknown as ArrayBuffer], { type: "application/pdf" });
          const pdfURL = URL.createObjectURL(pdfBlob);
          window.open(pdfURL, "_blank");
        } catch {
          toast.error("Something went wrong while downloading. Please try again later.", {
            position: toast.POSITION.BOTTOM_RIGHT,
            className: "foo-bar",
          });
        }
      } else {
        toast.error("Connection error. Please try again later.", {
          position: toast.POSITION.BOTTOM_RIGHT,
          className: "foo-bar",
        });
      }
    });
  };

  const downloadTemplate = () => {
    try {
      const link = document.createElement('a');
      link.href = '/templates/bulk_delivery_template.xlsx'; // Path relative to public folder
      link.setAttribute('download', 'bulk_delivery_template.xlsx');
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      toast.success("Template downloaded successfully", {
        position: toast.POSITION.BOTTOM_RIGHT,
        className: "foo-bar",
      });
    } catch (error) {
      console.error("Error downloading template:", error);
      toast.error("Failed to download template", {
        position: toast.POSITION.BOTTOM_RIGHT,
        className: "foo-bar",
      });
    }
  };

  const handleSelectOrder = (orderId: string) => {
    setSelectedOrders(prev =>
      prev.includes(orderId)
        ? prev.filter(id => id !== orderId)
        : [...prev, orderId]
    );
  };

  const handleSelectAllOrders = () => {
    if (selectedOrders.length === deliveryEntries.length) {
      setSelectedOrders([]);
    } else {
      setSelectedOrders(deliveryEntries.map(entry => entry.orderId));
    }
  };

  const handleDeleteSelected = async () => {
    if (selectedOrders.length === 0) {
      toast.error("Please select at least one order to delete", {
        position: toast.POSITION.BOTTOM_RIGHT,
        className: "foo-bar",
      });
      return;
    }

    if (!bulkRequestId) {
      toast.error("Bulk request ID is missing", {
        position: toast.POSITION.BOTTOM_RIGHT,
        className: "foo-bar",
      });
      return;
    }

    try {
      // Call the API to delete orders
      const response = await OrderService.bulkRequestOrdersDelete({
        bulkRequestId,
        orderIds: selectedOrders
      });

      if (response.success) {
        // Update local state only after successful API call
        setDeliveryEntries(prev =>
          prev.filter(entry => !selectedOrders.includes(entry.orderId))
        );
        setSelectedOrders([]);

        // Check if we need to clear the bulk request
        if (deliveryEntries.length - selectedOrders.length <= 0) {
          setBulkRequestId(null);
          setFieldsLocked(false);
          setUploadErrors([]);
          setUploadedFileName(null);
          setUploadSuccess(false);
          if (fileInputRef.current) {
            fileInputRef.current.value = "";
          }
        }

        toast.success(response.message || `${selectedOrders.length} order(s) deleted successfully`, {
          position: toast.POSITION.BOTTOM_RIGHT,
          className: "foo-bar",
        });
      } else {
        toast.error(response.message || "Failed to delete orders", {
          position: toast.POSITION.BOTTOM_RIGHT,
          className: "foo-bar",
        });
      }
    } catch (error) {
      console.error("Error deleting orders:", error);
      toast.error("Failed to delete orders", {
        position: toast.POSITION.BOTTOM_RIGHT,
        className: "foo-bar",
      });
    } finally {
      // setIsDeleting(false);
    }
  };

  return (
    <>
      <Modal isOpen={isOpen} toggle={toggle} size="xl" centered>
        <ModalHeader toggle={toggle}></ModalHeader>
        <ModalBody>
          <div className="px-5 py-2">
            <h4 className="bg-primary bg-opacity-25 popover-header py-3 text-center">
              New Bulk Request
            </h4>
            <form className="row g-2">
              <div>
                <h6 className="mt-2">Pickup Details</h6>
              </div>
              <Form>
                <Row>
                  <Col lg={6}>
                    <div className="mb-3 form-group">
                      <Label className="place-order-title me-2">
                        Pick - Up Address <span className="text-danger">*</span>
                      </Label>
                      <div style={fieldsLocked ? { pointerEvents: 'none', opacity: 0.7 } : {}}>
                        <CustomGooglePlacesAutocompleteOrders
                          apiKey={environment.google_maps_key}
                          autocompletionRequest={mapprops}
                          value={pickupValue}
                          setValue={setPickupValue}
                          addressType={AddressType.pickup}
                          selectProps={{ name: "address" }}
                          handleAddress={handleAddress}
                        />
                      </div>
                    </div>
                  </Col>
                  <Col lg={6}>
                    <div className="mb-3 form-group">
                      <Label className="place-order-title">
                        Pickup date & time <span className="text-danger">*</span>
                      </Label>
                      <DatePicker
                        onFocus={(e) => e.target.blur()}
                        selected={pickupDateTime ? pickupDateTime.toDate() : null}
                        onChange={handlePickupDateChange}
                        showTimeSelect
                        timeFormat="HH:mm"
                        timeIntervals={15}
                        dateFormat="yyyy-MM-dd HH:mm"
                        timeCaption="Time"
                        placeholderText="Select Date and Time"
                        className="form-control"
                        minDate={mindate.toDate()}
                        maxDate={moment().add(1, "year").toDate()}
                        minTime={
                          pickupDateTime && moment(pickupDateTime).isSame(moment(), "day")
                            ? moment().isBefore(moment("09:00", "HH:mm"))
                              ? moment("09:00", "HH:mm").toDate() // before 9 AM → min = 9 AM
                              : moment().toDate() // after 9 AM → min = now
                            : moment("09:00", "HH:mm").toDate() // other days → always 9 AM
                        }
                        maxTime={moment("21:00", "HH:mm").toDate()}
                        disabled={fieldsLocked}
                      />
                    </div>
                  </Col>
                </Row>

                <Row>
                  <Col lg={6}>
                    <div className="mb-3 form-group">
                      <Label className="place-order-title">
                        Delivery date & time <span className="text-danger">*</span>
                      </Label>
                      <DatePicker
                        onFocus={(e) => e.target.blur()}
                        selected={deliveryDateTime ? deliveryDateTime.toDate() : null}
                        onChange={handleDeliveryDateChange}
                        showTimeSelect
                        timeFormat="HH:mm"
                        timeIntervals={15}
                        dateFormat="yyyy-MM-dd HH:mm"
                        timeCaption="Time"
                        placeholderText="Select Date and Time"
                        className="form-control"
                        minDate={moment(pickupDateTime).toDate()}
                        maxDate={moment(pickupDateTime).toDate()}
                        minTime={getDeliveryMinTime()}
                        maxTime={getDeliveryMaxTime()}
                        disabled={fieldsLocked}
                      />
                    </div>
                  </Col>
                  <Col lg={6}>
                    <div className="mb-3 form-group">
                      <Label className="place-order-title">
                        Delivery method / handling (if unavailable)<Label className="title-star">*</Label>
                      </Label>
                      <Select
                        value={pickupDeliveryOption}
                        onChange={handleDeliveryOptionChange}
                        placeholder="--Select delivery option--"
                        className="form-select"
                        disabled={fieldsLocked}
                      >
                        <Select.Option value={DeliverOption.DROP_AT_DOOR}>Drop at door</Select.Option>
                        <Select.Option value={DeliverOption.DROP_AT_MAILBOX}>Drop at mailbox</Select.Option>
                        <Select.Option value={DeliverOption.DROP_AT_FRONT_DESK}>Drop at front desk</Select.Option>
                        <Select.Option value={DeliverOption.CALL_ME_TO_CONFIRM}>Call me to confirm</Select.Option>
                        <Select.Option value={DeliverOption.SIGNATURE_REQUIRED}>Signature Required</Select.Option>
                        <Select.Option value={DeliverOption.RETURN_ON_FAILED}>Return the package to me</Select.Option>
                        <Select.Option value={DeliverOption.REATTEMPT_ON_FAILED}>Reattempt for tomorrow</Select.Option>
                      </Select>
                    </div>
                  </Col>
                </Row>

                <Row>
                  <Col lg={6}>
                    <div className="mb-3 form-group">
                      <Label className="place-order-title">Choose Vehicle</Label>
                      <div className="col-lg-8 form-check">
                        <Radio.Group
                          value={pickupVehicleType}
                          onChange={handleVehicleTypeChange}
                          disabled={fieldsLocked}
                        >
                          <Radio value={VehicleType.CAR}>Car</Radio>
                          <Radio value={VehicleType.SUV}>SUV</Radio>
                          <Radio value={VehicleType.VAN}>Mini Van</Radio>
                        </Radio.Group>
                      </div>
                    </div>
                  </Col>

                </Row>
              </Form>

              {/* Delivery Entries */}
              <div className="mb-2 mt-4 d-flex justify-content-start align-items-center gap-2">
                <h6 className="py-2 m-0">Delivery Entries</h6>
                <button
                  type="button"
                  className="btn btn-sm btn-secondary  d-flex justify-content-center align-items-center"
                  style={{ width: "32px", height: "32px", fontWeight: 600 }}
                  // onClick={() => setShowAddModal(true)}
                  onClick={handleDeliveryEntryAdd}
                  disabled={!pickupAddress}
                >
                  <i className="bx bx-plus"></i>
                </button>
                {deliveryEntries.length > 0 && (
                  <button
                    type="button"
                    className="btn btn-sm btn-primary  d-flex justify-content-center align-items-center"
                    style={{ width: "32px", height: "32px", fontWeight: 600 }}
                    onClick={handleDeleteSelected}
                    disabled={!pickupAddress}
                  >
                    <i className="bx bx-trash"></i>
                  </button>

                )}
              </div>

              <div style={{ position: "relative" }}>
                {isLoading && (
                  <div
                    className="d-flex justify-content-center align-items-center flex-column"
                    style={{
                      position: "absolute",
                      top: 0,
                      left: 0,
                      width: "100%",
                      height: "100%",
                      background: "rgba(255,255,255,0.8)",
                      backdropFilter: "blur(3px)",
                      zIndex: 10,
                    }}
                  >
                    <Puff color="#50C878" height={60} width={60} />
                    {/* <div className="mt-3 fw-semibold text-muted">Loading delivery entries...</div> */}
                  </div>
                )}
              </div>

              <div className="table-responsive mb-3" style={{ maxHeight: "300px", overflowY: "auto" }}>
                <table className="table-white table-sm table-bordered align-middle w-100">
                  <thead className="text-center table-light">
                    <tr>
                      <th style={{ width: "50px" }}>
                        <label
                          className="d-flex justify-content-center align-items-center"
                          style={{
                            width: "20px",
                            height: "20px",
                            borderRadius: "4px",
                            border: "1px solid #ccc",
                            cursor: "pointer",
                          }}
                        >
                          <input
                            type="checkbox"
                            checked={
                              deliveryEntries.length > 0 &&
                              selectedOrders.length === deliveryEntries.length
                            }
                            onChange={handleSelectAllOrders}
                            className="form-check-input d-none"
                          />
                          {deliveryEntries.length > 0 &&
                            selectedOrders.length === deliveryEntries.length ? (
                            <i className="bx bx-check text-white bg-primary" style={{ fontSize: "16px" }}></i>
                          ) : null}
                        </label>
                      </th>

                      <th>Company</th>
                      <th>Contact</th>
                      <th>Address</th>
                      <th>Phone</th>
                      <th>#of items</th>
                      <th>Weight</th>
                      <th>Notes</th>
                      <th>Price</th>
                      <th>Distance</th>
                    </tr>
                  </thead>

                  {/* <tbody className="text-center">
                    {deliveryEntries.length === 0 ? (
                      <tr>
                        <td colSpan={10} className="text-muted">
                          No delivery entries added yet
                        </td>
                      </tr>
                    ) : (
                      deliveryEntries.map((entry) => (
                        <tr key={entry.id}>
                          <td style={{ width: "50px" }}>
                            <label
                              className="d-flex justify-content-center align-items-center"
                              style={{
                                width: "20px",
                                height: "20px",
                                borderRadius: "4px",
                                border: selectedOrders.includes(entry.orderId)
                                  ? "none"
                                  : "1px solid #ccc",
                                backgroundColor: selectedOrders.includes(entry.orderId)
                                  ? "#F28C28"
                                  : "transparent",
                                cursor: "pointer",
                              }}
                            >
                              <input
                                type="checkbox"
                                checked={selectedOrders.includes(entry.orderId)}
                                onChange={() => handleSelectOrder(entry.orderId)}
                                className="form-check-input d-none"
                              />
                              {selectedOrders.includes(entry.orderId) && (
                                <i className="bx bx-check text-white" style={{ fontSize: "16px" }}></i>
                              )}
                            </label>
                          </td>
                          <td>{entry.deliverCompany}</td>
                          <td>{entry.deliverContactName}</td>
                          <td>{entry.deliveryAddress?.city ?? "N/A"}</td>
                          <td>{entry.deliverContactPhone}</td>
                          <td>{entry.totalItems}</td>
                          <td>{entry.totalWeight} lbs</td>
                          <td>{entry.description} lbs</td>
                          <td>${entry.price?.toFixed(2) ?? "0.00"}</td>
                          <td>{entry.totalDistance}</td>
                        </tr>
                      ))
                    )}
                  </tbody> */}

                  <tbody className="text-center" style={{ position: "relative", minHeight: "200px" }}>
                    {deliveryEntries.length === 0 ? (
                      <tr>
                        <td colSpan={10} className="text-muted">
                          No delivery entries added yet
                        </td>
                      </tr>
                    ) : (
                      deliveryEntries.map((entry) => (
                        <tr key={entry.id}>
                          <td style={{ width: "50px" }}>
                            <label
                              className="d-flex justify-content-center align-items-center"
                              style={{
                                width: "20px",
                                height: "20px",
                                borderRadius: "4px",
                                border: selectedOrders.includes(entry.orderId)
                                  ? "none"
                                  : "1px solid #ccc",
                                backgroundColor: selectedOrders.includes(entry.orderId)
                                  ? "#F28C28"
                                  : "transparent",
                                cursor: "pointer",
                              }}
                            >
                              <input
                                type="checkbox"
                                checked={selectedOrders.includes(entry.orderId)}
                                onChange={() => handleSelectOrder(entry.orderId)}
                                className="form-check-input d-none"
                              />
                              {selectedOrders.includes(entry.orderId) && (
                                <i className="bx bx-check text-white" style={{ fontSize: "16px" }}></i>
                              )}
                            </label>
                          </td>
                          <td>{entry.deliverCompany}</td>
                          <td>{entry.deliverContactName}</td>
                          <td>{entry.deliveryAddress?.city ?? "N/A"}</td>
                          <td>{entry.deliverContactPhone}</td>
                          <td>{entry.totalItems}</td>
                          <td>{entry.totalWeight} lbs</td>
                          <td>{entry.description}</td>
                          <td>${entry.price?.toFixed(2) ?? "0.00"}</td>
                          <td>{entry.totalDistance}</td>
                        </tr>
                      ))
                    )}
                  </tbody>
                </table>
              </div>
              {deliveryEntries.length > 0 && (
                <div className="text-end  mt-2 me-2">
                  Total Price:{" "}
                  <span style={{ color: "#000000" }}>
                    ${totalPrice.toFixed(2)}
                  </span>
                </div>
              )}

              {/* File Upload */}
              <Row>
                <div className="col-12 col-md-6 mb-3">

                  <div className="d-flex gap-2">
                    <button
                      type="button"
                      className="btn btn-sm btn-outline-primary"
                      onClick={downloadTemplate}
                    >
                      <i className="bx bx-download me-1"></i> Download Template
                    </button>
                  </div>
                  <small className="text-muted">
                    Download our template file, fill it out, and upload below
                  </small>
                </div>
              </Row>
              <Row>
                <div className="col-12 col-md-4 mb-3">
                  <label className="form-label fw-semibold">File Upload (.xls or .csv)</label>
                  <div className="input-group">
                    <input
                      type="file"
                      className="form-control form-control-sm"
                      id="file-upload"
                      accept=".xlsx,.xls,.csv"
                      onChange={handleFileUpload}
                      disabled={!isPickupDetailsComplete()}
                      title={
                        uploadSuccess
                          ? "File already uploaded"
                          : !isPickupDetailsComplete()
                            ? "Please complete pickup details first"
                            : ""
                      }
                      ref={fileInputRef}
                    />
                    {/* {!isPickupDetailsComplete() && (
                    <small className="text-danger mt-1 d-block">
                      Please fill in pickup address and dates before uploading
                    </small>
                  )} */}
                  </div>
                </div>
              </Row>

              {uploadErrors.length > 0 && (
                <div
                  className="mt-2 p-2 border border-danger bg-light rounded"
                  style={{ maxHeight: "150px", overflowY: "auto" }}
                >
                  <strong className="text-danger d-block mb-1">
                    Some rows failed to upload:
                  </strong>
                  <ul className="mb-0">
                    {uploadErrors.map((err, idx) => (
                      <li key={idx} className="text-danger small">
                        {err}
                      </li>
                    ))}
                  </ul>
                </div>
              )}
            </form>
          </div>
        </ModalBody>

        <ModalFooter className="justify-content-end">
          <div className="px-5 py-2 w-100">
            <Row className="gx-3 justify-content-end">
              <Col xs={3}>
                {/* {bulkRequestId && (
                  <button
                    type="button"
                    className="btn btn-sm btn-secondary w-100"
                    onClick={() => handleDownloadPdf(bulkRequestId)}
                    disabled={deliveryEntries.length === 0}
                  >
                    Download (XLS or PDF)
                  </button>
                )} */}
              </Col>
              <Col xs={3}>
                <button
                  type="button"
                  className="btn btn-sm btn-primary w-100"
                  onClick={handleSubmit}
                  disabled={!pickupAddress || deliveryEntries.length === 0}
                >
                  Submit
                </button>
              </Col>
            </Row>
          </div>
        </ModalFooter>
      </Modal>

      <AddDeliveryEntryModal
        isOpen={showAddModal}
        toggle={() => setShowAddModal(false)}
        onSave={handleAddDeliveryEntry}
        pickupAddress={pickupAddress}
        pickupDateTime={pickupDateTime}
        deliveryDateTime={deliveryDateTime}
        userId={userId || undefined}
        bulkRequestId={bulkRequestId || undefined}
        defaultVehicleType={pickupVehicleType}
        defaultDeliveryOption={pickupDeliveryOption}
      />
    </>
  );
};

export default CreateBulk;



